import { For, Show } from 'solid-js';
import { FieldType } from '../forms-types';
import { getUniqueSlug } from '../utils';

type HiddenFieldsProps = {
    stepFields: FieldType[];
};

// Renders all `hiddenField` entries in the current step. The dispatcher invokes
// this once per hidden-field encountered, so every iteration re-emits all hidden
// inputs — preserved from the original implementation.
export const HiddenFields = (props: HiddenFieldsProps) => {
    const hidden = () => props.stepFields.filter(f => f.slug === 'hiddenField');

    return (
        <Show when={hidden().length > 0}>
            <For each={hidden()}>
                {(fieldData) => <input name={getUniqueSlug(fieldData)} hidden={true} />}
            </For>
        </Show>
    );
};
